import React from 'react';
import PropTypes from 'prop-types';

/**
 * @todo
 * The way that this component works suggests that it may be an example of
 * hasty abstractiion. In a future improvement work, we should consider
 * whether this needs to be removed or refactored to improve the health of
 * the codebase.
 */
function CustomFilterContainer({
  changeFilter,
  results,
  currentResults,
  placeholderText = '',
  customFilterComponent,
}) {
  if (typeof customFilterComponent !== 'function') {
    return <div />;
  }

  const CustomerFilterComponent = customFilterComponent;

  return (
    <CustomerFilterComponent
      changeFilter={changeFilter}
      results={results}
      currentResults={currentResults}
      placeholderText={placeholderText}
    />
  );
}

CustomFilterContainer.propTypes = {
  changeFilter: PropTypes.func,
  results: PropTypes.func,
  currentResults: PropTypes.func,
  placeholderText: PropTypes.func,
};

export { CustomFilterContainer };
